/* ============================================================================
 * NZ Supps — Stack Builder ("Build Your Stack")
 * ----------------------------------------------------------------------------
 * Self-initialising. For each [data-nzs-stack] root it reads the JSON emitted
 * by the section (#nzs-stack-data-<id>) and hydrates:
 *   - 4 category blocks (Creatine / Protein / Pre-Workout / Electrolytes)
 *   - a "free energy drinks" picker  (unlocks at 3 picks)
 *   - a "mystery gift" dice reveal          (unlocks at 4 picks)
 *   - a sticky order summary with live tier discounts + add-to-cart
 *
 * WHEN THE REAL PRICE LIST IS LOADED  (least-coding handover):
 *   1. In the theme editor, assign a real collection to each of the 6
 *      collection pickers on this section. That's it — real products,
 *      prices, images and variants flow in automatically; placeholder mode
 *      switches off on its own (see data-placeholder flag in the JSON).
 *   2. Create two discount codes in Shopify Admin and type their names into
 *      the section's "Discount code" fields (tier 2/3 = 5%, tier 4 = 10%).
 *      They are auto-applied at checkout via /checkout?discount=CODE.
 *   3. To make the samples + mystery gift actually $0, add ONE Shopify
 *      automatic "free gift" / Buy-X-Get-Y discount (or a free-gift app) that
 *      targets line items carrying the property  _Free  (= "Sample" or
 *      "Mystery gift"). Those properties are already attached below.
 * No JS edits are required for any of the above.
 * ========================================================================== */
(function () {
  'use strict';

  var ICON = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 7"/></svg>',
    lock:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    gift:  '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14.94 9V15.98C14.94 16.23 14.74 16.43 14.49 16.43H3.51C3.26 16.43 3.06 16.23 3.06 15.98V9"/><path d="M15.98 5.29H2.02C1.77 5.29 1.58 5.49 1.58 5.73V8.55C1.58 8.8 1.77 9 2.02 9H15.98C16.23 9 16.43 8.8 16.43 8.55V5.73C16.43 5.49 16.23 5.29 15.98 5.29Z"/><path d="M9 16.43V5.29"/><path d="M9 5.29H5.66C5.17 5.29 4.69 5.09 4.35 4.74C4 4.4 3.8 3.92 3.8 3.43C3.8 2.94 4 2.47 4.35 2.12C4.69 1.77 5.17 1.58 5.66 1.58C8.26 1.58 9 5.29 9 5.29Z"/><path d="M9 5.29H12.34C12.83 5.29 13.31 5.09 13.65 4.74C14 4.4 14.2 3.92 14.2 3.43C14.2 2.94 14 2.47 13.65 2.12C13.31 1.77 12.83 1.58 12.34 1.58C9.74 1.58 9 5.29 9 5.29Z"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/></svg>'
  };

  function money(cents, sym) {
    var n = (Number(cents) || 0) / 100;
    return (sym || '$') + n.toFixed(2);
  }
  function isPlaceholder(id) { return typeof id === 'string' && id.indexOf('ph-') === 0; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
  }); }

  /* ====================== real 3D die — 2D-canvas software renderer ======================
   * Why a canvas (not CSS 3D): CSS 3D has no per-pixel depth buffer (painter's algorithm), so a
   * freely-tumbling cube leaves see-through gaps at grazing/edge-on frames and looks flat at face-on
   * ones — unfixable (a backing core still leaves a corner wedge + z-fights). A cube is CONVEX, so
   * sorting its 6 faces back-to-front and filling them as OPAQUE polygons gives EXACT occlusion at
   * every angle — always solid. Pips are geometry ON the face plane (a ring of points in face-local
   * space pushed through the same rotate->project pipeline), so they foreshorten/skew WITH the face
   * (painted into the side, not stamped on top). Opposite faces sum to 7: +Z=1/-Z=6,+X=3/-X=4,-Y=2/+Y=5. */
  var DICE_V = [[-1,-1,-1],[1,-1,-1],[1,1,-1],[-1,1,-1],[-1,-1,1],[1,-1,1],[1,1,1],[-1,1,1]];
  var DICE_F = [
    { idx:[4,5,6,7], n:[0,0,1],  num:1 },
    { idx:[1,0,3,2], n:[0,0,-1], num:6 },
    { idx:[5,1,2,6], n:[1,0,0],  num:3 },
    { idx:[0,4,7,3], n:[-1,0,0], num:4 },
    { idx:[4,0,1,5], n:[0,-1,0], num:2 },
    { idx:[7,6,2,3], n:[0,1,0],  num:5 }
  ];
  // pip centres in face-local (u,v) in [-1,1]; tuned toward the corners like a real die
  var DICE_PIP = {
    1:[[0,0]],
    2:[[-0.62,-0.62],[0.62,0.62]],
    3:[[-0.62,-0.62],[0,0],[0.62,0.62]],
    4:[[-0.62,-0.62],[0.62,-0.62],[-0.62,0.62],[0.62,0.62]],
    5:[[-0.62,-0.62],[0.62,-0.62],[0,0],[-0.62,0.62],[0.62,0.62]],
    6:[[-0.62,-0.66],[0.62,-0.66],[-0.62,0],[0.62,0],[-0.62,0.66],[0.62,0.66]]
  };
  var DICE_L = (function () { var l=[-0.35,-0.55,0.72], m=Math.hypot(l[0],l[1],l[2]); return [l[0]/m,l[1]/m,l[2]/m]; })();
  var TAU = 6.283185307;

  function diceHtml() { return '<canvas class="sb-dice-cv" data-dice aria-hidden="true"></canvas>'; }

  // Self-contained die renderer bound to a <canvas>. API: init(), roll(onDone), destroy().
  function createDiceRenderer(canvas) {
    var dpr = Math.min(Math.max(window.devicePixelRatio || 1, 1), 3);
    // Canvas box (180) is bigger than the die so the cube never clips its own bitmap while tumbling/
    // hopping (a canvas hard-clips to its width/height). SC keeps the die ~120px with ~14px of margin.
    var S = Math.round(180 * dpr);
    canvas.width = S; canvas.height = S;
    var ctx = canvas.getContext('2d');
    var D = 5.2, SC = S * 0.225, CEN = S / 2, LW = 1.7 * dpr, PR = 0.17;
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function rot(p, ax, ay, az) {
      var x=p[0], y=p[1], z=p[2], c, s, t;
      c=Math.cos(ax); s=Math.sin(ax); t=y*c-z*s; z=y*s+z*c; y=t;
      c=Math.cos(ay); s=Math.sin(ay); t=x*c+z*s; z=-x*s+z*c; x=t;
      c=Math.cos(az); s=Math.sin(az); t=x*c-y*s; y=x*s+y*c; x=t;
      return [x, y, z];
    }
    function proj(p) { var f = D / (D - p[2]); return [CEN + p[0]*SC*f, CEN + p[1]*SC*f]; }
    function flw(f, u, v) {                          // face-local (u,v) -> world point on the face plane
      var i, p0=DICE_V[f.idx[0]], p1=DICE_V[f.idx[1]], p2=DICE_V[f.idx[2]], p3=DICE_V[f.idx[3]], o=[0,0,0];
      for (i=0;i<3;i++) {
        var c = (p0[i]+p1[i]+p2[i]+p3[i]) / 4;
        o[i] = c + (p1[i]-p0[i])/2*u*0.62 + (p3[i]-p0[i])/2*v*0.62;
      }
      return o;
    }
    function draw(ax, ay, az) {
      ctx.clearRect(0,0,S,S);
      var tv = DICE_V.map(function (p) { return rot(p, ax, ay, az); });
      var fs = DICE_F.map(function (f) {
        return { f:f, tn:rot(f.n,ax,ay,az), cz:(tv[f.idx[0]][2]+tv[f.idx[1]][2]+tv[f.idx[2]][2]+tv[f.idx[3]][2])/4 };
      }).sort(function (a,b) { return a.cz - b.cz; });   // far -> near (painter's, exact for a convex cube)
      for (var k=0;k<fs.length;k++) {
        var f = fs[k].f, tn = fs[k].tn, pts = f.idx.map(function (i) { return proj(tv[i]); });
        var nl = Math.max(0, tn[0]*DICE_L[0] + tn[1]*DICE_L[1] + tn[2]*DICE_L[2]);
        var sh = 0.90 + 0.10*nl, g = Math.round(255*sh), e = Math.round(246*sh), i;  // whiter faces, subtle shade
        ctx.beginPath(); ctx.moveTo(pts[0][0],pts[0][1]);
        for (i=1;i<4;i++) ctx.lineTo(pts[i][0],pts[i][1]);
        ctx.closePath();
        var gr = ctx.createLinearGradient(pts[0][0],pts[0][1],pts[2][0],pts[2][1]);
        gr.addColorStop(0,'rgb('+g+','+g+','+g+')'); gr.addColorStop(1,'rgb('+e+','+e+','+e+')');
        ctx.fillStyle = gr; ctx.fill();
        ctx.lineJoin='round'; ctx.lineWidth = LW; ctx.strokeStyle = '#0A0E15'; ctx.stroke();
        if (tn[2] > 0.02) {                            // front-facing: paint pips INTO the face
          ctx.fillStyle = '#0A0E15';
          var pips = DICE_PIP[f.num];
          for (var pi=0; pi<pips.length; pi++) {
            ctx.beginPath();
            for (var a=0; a<22; a++) {
              var th = a/22*TAU;
              var sp = proj(rot(flw(f, pips[pi][0]+PR*Math.cos(th), pips[pi][1]+PR*Math.sin(th)), ax, ay, az));
              if (a===0) ctx.moveTo(sp[0],sp[1]); else ctx.lineTo(sp[0],sp[1]);
            }
            ctx.closePath(); ctx.fill();
          }
        }
      }
    }

    function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
    function easeOut(t) { return 1 - Math.pow(1-t, 4); }   // quart — long, gentle deceleration to a slow halt

    var REST = { ax:-0.45, ay:0.62, az:0 };
    var raf = 0, destroyed = false, mode = 'idle', visible = true;
    var from = null, to = null, t0 = 0, ROLLDUR = 2300, onEnd = null, io = null;

    function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    function start() { if (!raf && !destroyed && visible && mode !== 'landed') raf = requestAnimationFrame(loop); }
    function loop() {
      raf = 0;
      if (destroyed) return;
      var t = now();
      if (mode === 'rolling') {
        var p = Math.min(1, (t - t0) / ROLLDUR), k = easeOut(p);
        draw(from.ax+(to.ax-from.ax)*k, from.ay+(to.ay-from.ay)*k, from.az+(to.az-from.az)*k);
        if (p >= 1) {
          mode = 'landed'; REST = { ax:to.ax, ay:to.ay, az:to.az };
          draw(REST.ax, REST.ay, REST.az);
          var cb = onEnd; onEnd = null;
          if (cb) cb();
          return;                                    // static from here -> zero CPU
        }
      } else {                                        // idle: gentle rock between two 3-face corner poses
        draw(REST.ax, REST.ay + Math.sin(t/5200*TAU)*0.16, 0);
      }
      start();
    }

    function init() {
      if (reduce) { mode = 'landed'; draw(REST.ax, REST.ay, REST.az); return; }
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          if (visible) start(); else stop();
        }, { threshold: 0.01 });
        io.observe(canvas);
      }
      mode = 'idle'; draw(REST.ax, REST.ay, 0); start();
    }
    function roll(cb) {
      if (reduce) {
        REST = { ax:-0.5+Math.random()*0.3, ay:Math.random()*TAU, az:(Math.random()-0.5)*0.4 };
        mode = 'landed'; draw(REST.ax, REST.ay, REST.az); if (cb) cb(); return;
      }
      var t = now();
      var curAy = (mode === 'idle') ? (REST.ay + Math.sin(t/5200*TAU)*0.16) : REST.ay;
      from = { ax:REST.ax, ay:curAy, az:REST.az };
      function sign() { return Math.random() < 0.5 ? -1 : 1; }
      function turns() { return (2 + Math.floor(Math.random()*2)) * TAU; }   // 2-3 turns (lower roll speed)
      to = {                                          // random landed pose + several full tumbles
        ax: (-0.62 + Math.random()*0.5) + sign()*turns(),
        ay: (Math.random()*TAU)         + sign()*turns(),
        az: ((Math.random()-0.5)*0.5)   + sign()*(0.6+Math.random()*0.8)*TAU
      };
      onEnd = cb || null; t0 = t; mode = 'rolling'; start();
    }
    function destroy() { destroyed = true; stop(); if (io) { io.disconnect(); io = null; } }

    return { init:init, roll:roll, destroy:destroy };
  }

  function StackBuilder(root) {
    var dataEl = document.getElementById(root.getAttribute('data-nzs-stack'));
    if (!dataEl) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.error('[stack] bad data', e); return; }

    var cfg = DATA.config || {};
    var SYM = cfg.currencySymbol || '$';
    function sampleTarget(){ return SUPPLY === '60' ? (cfg.sampleCount60 || 3) : (cfg.sampleCount || 1); }
    function mysteryTarget(){ return SUPPLY === '60' ? 2 : 1; }
    function energyWord(n){ return n + ' free energy drink' + (n === 1 ? '' : 's'); }
    function giftWord(n){ return n + ' mystery gift' + (n === 1 ? '' : 's'); }
    function supplyNote(){
      var e60 = (cfg.sampleCount60 || 3), e30 = (cfg.sampleCount || 1), g60 = 2, g30 = 1;
      if (SUPPLY === '60') {
        return '<i class="fi fi-rr-bolt" aria-hidden="true"></i><span>60-day selected — <b>' + energyWord(e60) + ' + ' + giftWord(g60) + '</b>, two months covered with fewer reorders.</span>';
      }
      return '<i class="fi fi-rr-bolt" aria-hidden="true"></i><span>Stocking up? Go 60-day for <b>' + energyWord(e60) + ' + ' + giftWord(g60) + '</b> (vs ' + e30 + ' + ' + g30 + ') — two months sorted, fewer reorders.</span>';
    }
    function clampFree(){
      var st = sampleTarget(), ids = Object.keys(samples);
      while (sampleQtyTotal() > st && ids.length) {
        var id = ids[ids.length - 1];
        if (samples[id] && samples[id].qty > 0) { samples[id].qty--; if (samples[id].qty === 0) { delete samples[id]; ids.pop(); } }
        else { ids.pop(); }
      }
      if (mystery.length > mysteryTarget()) mystery = mystery.slice(0, mysteryTarget());
    }
    function updateLadder(){
      Array.prototype.forEach.call(root.querySelectorAll('[data-sb-energy]'), function (el){ el.textContent = energyWord(sampleTarget()); });
      var _sbNote = root.querySelector('[data-sb-supply-note]'); if (_sbNote) _sbNote.innerHTML = supplyNote();
      Array.prototype.forEach.call(root.querySelectorAll('[data-sb-gift]'), function (el){ el.textContent = mysteryTarget() > 1 ? (mysteryTarget() + ' free mystery gifts') : 'Free mystery gift'; });
    }
    var SAMPLES_AT = cfg.samplesUnlockAt || 3;
    var MYSTERY_AT = cfg.mysteryUnlockAt || 4;
    var CATS30 = DATA.categories || [];
    var CATS60 = (DATA.categories60 && DATA.categories60.length) ? DATA.categories60 : CATS30;
    var CATS = CATS30;            // active set (swapped by the 30/60-day toggle)
    var SUPPLY = '30';           // '30' | '60'
    var SAMPLES = (DATA.samples && DATA.samples.products) || [];

    /* ===== NZS-BYS-LIVE ==========================================================
       Price / compare-at / stock must come from Shopify, not the custom.bys_flavours
       snapshot (which had drifted: Ghost Whey showed $104.95 vs a real $83.96).
       - BASE products are already live: nzs-stack-cat.liquid emits product.price,
         product.compare_at_price and product.available straight from Liquid.
       - Flavour SIBLINGS come from the metafield. We verify the selected sibling against
         /products/{handle}.js so a stale snapshot can never sell a sold-out flavour or a
         wrong price. Nothing is fetched until a non-default flavour is actually picked. */
    var LIVE = {}, LIVE_REQ = {};
    var SAMPLE_SHOW = 6;              // pool of 12 configured; 6 shown, the rest are stock-out backups
    /* NZS-SPD-0808 — the self-heal above never actually fired. Two keying bugs, both fixed here:
         1. handleOf() fell back to the BASE product's url when a snapshot entry had no `handle`
            (and no entry has one — 1156/1156 measured 2026-08-08). Every sibling therefore
            resolved to the base handle, so we fetched the base product and learned nothing.
         2. the result was cached under the FETCHED product's id, while liveOf() looked it up by
            the SIBLING's id — LIVE[f.id] could never populate, so the stale snapshot won forever
            and LIVE_REQ blocked any retry.
       LIVE is now keyed by the handle we actually fetched and stores every variant, and a sibling
       with no handle resolves to nothing rather than to the wrong product. Missing handles are a
       no-op until scripts\regen_snapshots.py adds them. */
    function handleOf(f) {
      if (f && f.handle) return f.handle;
      var m = String((f && f.url) || '').split('/products/')[1];
      return m ? m.split('?')[0].split('#')[0] : '';
    }
    function liveFetch(handle, cb) {
      if (!handle || LIVE_REQ[handle]) return;
      LIVE_REQ[handle] = 1;
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (pj) {
          var vs = pj.variants || [], byVid = {}, i, v;
          for (i = 0; i < vs.length; i++) {
            v = vs[i];
            byVid[String(v.id)] = { price: v.price, compare_at_price: v.compare_at_price || 0,
                                    available: v.available !== false, vid: v.id };
          }
          v = vs[0] || {};
          LIVE[handle] = {
            byVid: byVid,
            first: { price: v.price, compare_at_price: v.compare_at_price || 0,
                     available: v.available !== false, vid: v.id }
          };
          cb && cb();
        })
        .catch(function () { /* network/404: keep the snapshot value, never block the UI */ });
    }
    // Shopify truth for a flavour entry when we have it; snapshot otherwise (and go fetch it).
    function liveOf(f, p, isBase) {
      if (isBase) {                                   // the card's own product: already live from Liquid
        var bv = (p.variants || [])[0] || {};
        return { price: p.price, compare_at_price: p.compare_at_price || 0,
                 available: p.available !== false, vid: bv.id || f.vid };
      }
      var h = handleOf(f);
      var L = h ? LIVE[h] : null;
      if (L) return (f.vid != null && L.byVid[String(f.vid)]) || L.first;
      if (h) liveFetch(h, function () { renderBlocks(); summary(); });
      // `c` is the legacy compare-at slot every existing snapshot entry still uses.
      return { price: f.price, compare_at_price: f.compare_at_price || f.c || 0,
               available: f.available !== false, vid: f.vid };
    }
    var MYSTERY = (DATA.mystery && DATA.mystery.products) || [];

    // 60-day supply: a pick is qty x2 when its 60-day product is the SAME as the 30-day one
    // (no bigger size in the catalogue); when the 60-day set swapped in a genuinely larger
    // product (e.g. 150g -> 500g), that bigger product is qty 1.
    function supplyQty(product, catKey) {
      // Serve-aware: ship the units needed to cover the window from the product's own servings
      // (~1 serve/day). 30-serve tub = 1 (30-day) / 2 (60-day); 16-serve = 2 / 4; 72-serve = 1 / 1.
      var days = SUPPLY === '60' ? 60 : 30;
      var s = parseInt(product.servings, 10) || 0;
      if (s <= 0) return 1;
      return Math.max(1, Math.round(days / s));
    }
    // {qty, price (cents, ×qty), servings (×qty), doubled} for a pick under the current supply
    function supplyCtx(product, catKey, v) {
      var q = supplyQty(product, catKey);
      var s = parseInt(product.servings, 10) || 0;
      var cmp = Number(v.compare_at_price || product.compare_at_price || 0);   // NZS-BYS-LIVE
      var price = Number(v.price) * q;
      var compare = cmp * q;
      return { qty: q, price: price, compare: (compare > price ? compare : 0),
               servings: s * q, doubled: q > 1 };
    }
    function setSupply(mode) {
      if (mode === SUPPLY) return;
      var from = SUPPLY === '60' ? CATS60 : CATS30;
      var to   = mode === '60' ? CATS60 : CATS30;
      var newSel = {};
      for (var k in sel) {
        if (!sel[k]) continue;
        var fc = from.find(function (c) { return c.key === k; });
        var tc = to.find(function (c) { return c.key === k; });
        if (!fc || !tc) continue;
        var idx = fc.products.findIndex(function (p) { return String(p.id) === String(sel[k].product.id); });
        if (idx >= 0 && tc.products[idx] && tc.products[idx].available !== false) {
          var np = tc.products[idx];
          var newFid = defaultFlavourId(np);
          var oldF = flavourEntry(sel[k].product, sel[k].flavourId);   // keep the same flavour after the supply swap when it exists
          if (oldF && oldF.flavour && hasFlavours(np)) {
            var npool = sizeFlavours(np);   // match the same flavour within the NEW mode's size group only
            for (var fi = 0; fi < npool.length; fi++) { if (npool[fi].flavour === oldF.flavour) { newFid = npool[fi].id; break; } }
          }
          newSel[k] = { product: np, flavourId: newFid, variantId: firstAvailableVariant(viewProduct(np, newFid)).id };
        }
      }
      sel = newSel; SUPPLY = mode; CATS = to;
      clampFree(); updateLadder();
      var seg = root.querySelector('[data-sb-supply]');
      if (seg) Array.prototype.forEach.call(seg.querySelectorAll('[data-supply]'), function (b) {
        var on = b.getAttribute('data-supply') === mode;
        b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      renderBlocks(); summary();
    }

    // ---- state ----
    var sel = {};                 // catKey -> { product, variantId }
    var samples = {};             // productId -> { product, variantId, qty }
    var mystery = [];             // [{ product, variantId }] (1 on 30-day, 2 on 60-day)
    var rolling = false;
    var diceR = null;             // active canvas dice renderer (one per render; rebuilt each renderBlocks)
    var prevLineKeys = {};        // summary line keys present last render -> animate ONLY newly-added lines
    var bypassLeave = false;      // true when we intentionally navigate (Add -> review) so the leave-guard stays quiet
    var leaveArmed = false, armLeave = null;   // NZS-SPD-0927-V12: beforeunload attached on the first pick

    // ---- el refs ----
    var elBlocks  = root.querySelector('[data-sb-blocks]');
    var elSummary = root.querySelector('[data-sb-summary]');
    var elLadder  = root.querySelector('[data-sb-ladder]');

    // ----- helpers -----
    function pickCount() {
      var n = 0; for (var k in sel) if (sel[k]) n++; return n;
    }
    function discountPct(n) {
      if (n >= 4) return Number(cfg.tier4Discount) || 0;
      if (n >= 3) return Number(cfg.tier3Discount) || 0;
      if (n >= 2) return Number(cfg.tier2Discount) || 0;
      return 0;
    }
    function nextTier(n) {
      var cur = discountPct(n);
      for (var m = n + 1; m <= 4; m++) { var p = discountPct(m); if (p > cur) return { need: m - n, extra: p - cur, pct: p }; }
      return null;
    }
    function sampleQtyTotal() {
      var t = 0; for (var id in samples) t += samples[id].qty; return t;
    }
    function variantOf(product, variantId) {
      var vs = product.variants || [];
      for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(variantId)) return vs[i];
      return vs[0] || { id: product.id, price: product.price };
    }
    function firstAvailableVariant(product) {
      var vs = product.variants || [];
      for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
      return vs[0] || { id: product.id, price: product.price, title: '' };
    }
    // ---- flavour grouping: a "family" card bundles sibling flavour PRODUCTS (p.flavours[]) ----
    // Picking one swaps the card image/title/price/serves AND the cart variant (the requested image swap).
    // Each flavour entry is a single-variant product: {id, vid, flavour, size, title, image, price, servings, available}.
    function hasFlavours(p) { return !!(p && p.flavours && p.flavours.length > 1); }
    function flavourEntry(p, flavourId) {
      if (!hasFlavours(p)) return null;
      for (var i = 0; i < p.flavours.length; i++) if (String(p.flavours[i].id) === String(flavourId)) return p.flavours[i];
      return null;
    }
    // The base product's own size (its entry where id === p.id) = the CURRENT supply mode's size, because
    // the 30-day / 60-day curated list decides which sized product is the card's base.
    function baseSizeOf(p) {
      if (!p || !p.flavours || !p.flavours.length) return '';
      var f = flavourEntry(p, p.id);
      if (f) return f.size || '';
      for (var i = 0; i < p.flavours.length; i++) if (p.flavours[i].available !== false) return p.flavours[i].size || '';
      return p.flavours[0].size || '';
    }
    // Flavours of the CURRENT size only — volume is locked to the supply mode (no cross-size picking in the
    // dropdown). Switching 30↔60-day swaps the base product (hence the size). Empty size = its own group.
    function sizeFlavours(p) {
      if (!p || !p.flavours) return [];
      var bs = baseSizeOf(p);
      return p.flavours.filter(function (f) { return (f.size || '') === bs; });
    }
    function defaultFlavourId(p) {
      if (!hasFlavours(p)) return null;
      var pool = sizeFlavours(p); if (pool.length < 1) pool = p.flavours;   // current-size options only
      var i;
      for (i = 0; i < pool.length; i++) if (String(pool[i].id) === String(p.id)) return pool[i].id;   // the curated default
      for (i = 0; i < pool.length; i++) if (pool[i].available !== false) return pool[i].id;
      return pool[0].id;
    }
    function pretty(s) {
      return String(s || '').split('-').map(function (w) { return /^[a-z]/.test(w) ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join(' ');
    }
    // Single-size dropdowns -> show the clean flavour name (size suffix only as a last-resort fallback).
    function flavourLabel(f) {
      if (f.flavour && f.flavour.toLowerCase() !== 'unflavoured') return pretty(f.flavour);
      if (f.size) return pretty(f.size);
      return f.label || f.title || 'Option';
    }
    // A product-like VIEW reflecting the chosen flavour (single variant); the base product when no flavour siblings.
    function viewProduct(p, flavourId) {
      var f = flavourEntry(p, flavourId);
      if (!f) return p;                                // no siblings: p is already live from Liquid
      var isBase = String(f.id) === String(p.id);      // NZS-BYS-LIVE
      var lv = liveOf(f, p, isBase);                   // Shopify truth, not the stale snapshot
      /* NZS-SPD-0808: a sibling's own handle/url, never the base's — the old fallback pointed
         every flavour's "view product" link at the base product. Falls back to the base only when
         the snapshot gives us nothing to point at (pre-regen entries carry no handle). */
      var fh = isBase ? p.handle : handleOf(f);
      var furl = isBase ? (p.url || f.url) : (fh ? '/products/' + fh : (f.url || p.url));
      return {
        id: p.id, flavourId: f.id, title: f.title || p.title, brand: p.brand, url: furl,
        handle: fh,
        image: f.image || p.image, price: lv.price, compare_at_price: lv.compare_at_price || 0,
        available: lv.available !== false,
        servings: (f.servings !== undefined && f.servings !== '' && f.servings !== null) ? f.servings : p.servings,
        core: p.core,                                  // siblings share ingredients -> keep the base panel
        variants: [{ id: lv.vid, title: f.title || '', price: lv.price,
                     compare_at_price: lv.compare_at_price || 0, available: lv.available !== false }],
        flavours: p.flavours
      };
    }
    function selView(s) { return s ? viewProduct(s.product, s.flavourId) : null; }
    // Gate free rewards by tier in ONE place: if the shopper drops below an
    // unlock threshold (e.g. removes a pick), discard the now-unearned items so
    // they can never linger in the summary or the cart payload.
    function enforceTiers() {
      if (pickCount() < SAMPLES_AT) samples = {};
      if (pickCount() < MYSTERY_AT) mystery = [];
      if (mystery.length > mysteryTarget()) mystery = mystery.slice(0, mysteryTarget());
    }

    // ---- localStorage persistence: restore the in-progress stack on re-entry; cleared on commit ----
    function findProd(list, pid) {
      for (var i = 0; i < (list || []).length; i++) if (String(list[i].id) === String(pid)) return list[i];
      return null;
    }
    function saveState() {
      try {
        var s = { supply: SUPPLY, sel: {}, samples: {}, mystery: [] }, k, id;
        for (k in sel) { if (sel[k]) s.sel[k] = { pid: String(sel[k].product.id), vid: String(sel[k].variantId), fid: sel[k].flavourId != null ? String(sel[k].flavourId) : '' }; }
        for (id in samples) { if (samples[id] && samples[id].qty > 0) s.samples[id] = { pid: String(samples[id].product.id), vid: String(samples[id].variantId), qty: samples[id].qty }; }
        mystery.forEach(function (g) { s.mystery.push({ pid: String(g.product.id), vid: String(g.variantId) }); });
        if (!Object.keys(s.sel).length && !Object.keys(s.samples).length && !s.mystery.length) { localStorage.removeItem('nzs_stack_saved'); return; }
        localStorage.setItem('nzs_stack_saved', JSON.stringify(s));
      } catch (e) { }
    }
    function restoreState() {
      var s, k, id; try { s = JSON.parse(localStorage.getItem('nzs_stack_saved') || 'null'); } catch (e) { return; }
      if (!s) return;
      if (s.supply === '60' || s.supply === '30') { SUPPLY = s.supply; CATS = SUPPLY === '60' ? CATS60 : CATS30; }
      if (s.sel) for (k in s.sel) {
        var cat = CATS.find(function (c) { return c.key === k; }); if (!cat) continue;
        var p = findProd(cat.products, s.sel[k].pid); if (!p || p.available === false) continue;
        var rfe = s.sel[k].fid ? flavourEntry(p, s.sel[k].fid) : null;   // restored flavour must be in the current mode's size group
        var fid = (rfe && (rfe.size || '') === baseSizeOf(p)) ? s.sel[k].fid : defaultFlavourId(p);
        var vp = viewProduct(p, fid);
        var v = variantOf(vp, s.sel[k].vid);
        var vid = (v && String(v.id) === String(s.sel[k].vid) && v.available !== false) ? s.sel[k].vid : firstAvailableVariant(vp).id;
        sel[k] = { product: p, flavourId: fid, variantId: vid };
      }
      if (s.samples) for (id in s.samples) {
        var sp = findProd(SAMPLES, s.samples[id].pid); if (!sp || sp.available === false) continue;
        samples[id] = { product: sp, variantId: s.samples[id].vid || firstAvailableVariant(sp).id, qty: Math.max(1, s.samples[id].qty || 1) };
      }
      if (s.mystery) s.mystery.forEach(function (m) {
        var mp = findProd(MYSTERY, m.pid); if (!mp || mp.available === false) return;
        mystery.push({ product: mp, variantId: m.vid || firstAvailableVariant(mp).id });
      });
      var seg = root.querySelector('[data-sb-supply]');
      if (seg) Array.prototype.forEach.call(seg.querySelectorAll('[data-supply]'), function (b) {
        var on = b.getAttribute('data-supply') === SUPPLY; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    // ---- leave-flow guard: warn before navigating away with an unfinished stack ----
    function installLeaveGuard() {
      if (!document.getElementById('nzs-leavewarn-css')) {
        var st = document.createElement('style'); st.id = 'nzs-leavewarn-css';
        st.textContent = '.nzs-leavewarn{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px}'
          + '.nzs-leavewarn__bd{position:absolute;inset:0;background:rgba(10,14,21,.55)}'
          + '.nzs-leavewarn__card{position:relative;background:#fff;border-radius:18px;max-width:420px;width:100%;padding:28px 24px;box-shadow:0 24px 60px rgba(10,14,21,.3);text-align:center}'
          + ".nzs-leavewarn__card h3{margin:0 0 8px;font:800 italic 22px/1.1 var(--font-display,'Saira',sans-serif);text-transform:uppercase;color:#0A0E15}"
          + ".nzs-leavewarn__card p{margin:0 0 20px;font:400 14px/1.5 var(--font-body,'Barlow',sans-serif);color:#414b5a}"
          + '.nzs-leavewarn__btns{display:flex;flex-direction:column;gap:10px}'
          + '.nzs-leavewarn__btns .btn{width:100%}'
          + ".nzs-leavewarn__leave{background:none;border:0;color:#6b7280;font:600 13px var(--font-body,'Barlow',sans-serif);cursor:pointer;padding:8px;text-decoration:underline}";
        document.head.appendChild(st);
      }
      function modal(onLeave) {
        var m = document.createElement('div'); m.className = 'nzs-leavewarn';
        m.innerHTML = '<div class="nzs-leavewarn__bd" data-x></div><div class="nzs-leavewarn__card" role="dialog" aria-modal="true" aria-label="Leave your stack?">'
          + '<h3>Leave your stack?</h3><p>Leave now and you\u2019ll lose your stack and these deals \u2014 your free items and stack discount won\u2019t carry over.</p>'
          + '<div class="nzs-leavewarn__btns"><button type="button" class="btn btn--accent lg" data-stay><span>Stay &amp; finish</span></button>'
          + '<button type="button" class="nzs-leavewarn__leave" data-go>Leave anyway</button></div></div>';
        document.body.appendChild(m);
        var html = document.documentElement, prev = html.style.overflow; html.style.overflow = 'hidden';
        function close() { m.remove(); html.style.overflow = prev; }
        m.querySelector('[data-stay]').addEventListener('click', close);
        m.querySelector('[data-x]').addEventListener('click', close);
        m.querySelector('[data-go]').addEventListener('click', function () { close(); onLeave(); });
      }
      document.addEventListener('click', function (e) {
        if (bypassLeave || pickCount() < 1) return;
        var a = e.target.closest('a[href]'); if (!a || a.target === '_blank') return;
        var href = a.getAttribute('href') || '';
        if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;
        var url; try { url = new URL(a.href, location.href); } catch (_) { return; }
        if (url.origin !== location.origin || url.pathname === location.pathname) return;
        if (/\/pages\/(your-stack|build-your-stack)\b/.test(url.pathname)) return;  // advancing in / staying in the flow
        e.preventDefault(); e.stopPropagation();
        modal(function () { bypassLeave = true; window.location.href = a.href; });
      }, true);
      /* NZS-SPD-0927-V12: same prompt + conditions, attached on the first pick (summary() arms it) rather than at load */
      armLeave = function () {
        if (leaveArmed) return; leaveArmed = true;
        window.addEventListener('beforeunload', function (e) {
          if (bypassLeave || pickCount() < 1) return;
          e.preventDefault(); e.returnValue = ''; return '';
        });
      };
      if (pickCount() >= 1) armLeave();   // picks restored before this guard was set up
    }

    /* ====================== RENDER: category blocks ====================== */
    // "$X.XX/serve · N serves" from the custom.servings metafield (omitted when absent).
    // Takes already-supply-adjusted price (cents) + servings so 60-day doubling flows through.
    function serveLine(priceCents, servings) {
      var s = parseInt(servings, 10);
      if (!s || s <= 0) return '';
      var per = Math.round(Number(priceCents) / s);   // cents/serve
      return '<span class="sb-card__serve">' + money(per, SYM) + '/serve <i>&middot;</i> ' + s + ' serves</span>';
    }
    // Collapsible Core Ingredients summary (pre-workouts) from custom.core_ingredients
    // ("Name|Amount|Bar%\n..."). Rendered as a span inside the card button; the toggle is
    // intercepted in the block click handler so it never selects the product.
    function ingredientPanel(p) {
      if (!p.core) return '';
      var rows = String(p.core).split('\n').filter(Boolean).slice(0, 5).map(function (line) {
        var pt = line.split('|'); var nm = pt[0] || '', amt = pt[1] || '', pct = parseFloat(pt[2] || '0') || 0;
        if (!nm) return '';
        return '<span class="sb-ingr__row"><span class="sb-ingr__n">' + esc(nm) + '</span>' +
          '<span class="sb-ingr__bar"><i style="width:' + Math.max(5, Math.min(100, pct)) + '%"></i></span>' +
          '<span class="sb-ingr__a">' + esc(amt) + '</span></span>';
      }).join('');
      if (!rows) return '';
      return '<span class="sb-ingr">' +
        '<span class="sb-ingr__tog" data-ingr-toggle role="button" tabindex="0">Core ingredients' +
          '<svg viewBox="0 0 24 24" class="sb-ingr__chev" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span>' +
        '<span class="sb-ingr__panel"><span class="sb-ingr__inner">' + rows + '</span></span></span>';
    }
    function productCard(cat, p) {
      var chosen = sel[cat.key] && String(sel[cat.key].product.id) === String(p.id);
      var fid = chosen ? sel[cat.key].flavourId : defaultFlavourId(p);   // null when the family has no flavour siblings
      var vp = viewProduct(p, fid);                                      // base product, or the chosen-flavour view
      var v = chosen ? variantOf(vp, sel[cat.key].variantId) : firstAvailableVariant(vp);
      var ctx = supplyCtx(vp, cat.key, v);
      var supplyTag = ctx.qty > 1 ? '<span class="sb-card__x2">×' + ctx.qty + ' &middot; ' + (SUPPLY === '60' ? '60' : '30') + '-day supply</span>'
        : (SUPPLY === '60' ? '<span class="sb-card__x2">60-day supply</span>' : '');
      // flavour dropdown — siblings of the CURRENT size only (volume is set by the 30/60-day toggle, not here)
      var flavourSel = '';
      var fopts = sizeFlavours(p);
      if (fopts.length > 1) {
        flavourSel = '<div class="sb-card__flavour"><select data-sb-flavour aria-label="Flavour for ' + esc(p.title) + '">' +
          fopts.map(function (f) {
            return '<option value="' + f.id + '"' + (String(f.id) === String(fid) ? ' selected' : '') +
              (f.available === false ? ' disabled' : '') + '>' + esc(flavourLabel(f)) + '</option>';
          }).join('') + '</select></div>';
      }
      var hasVariants = (vp.variants || []).length > 1;   // in-product size variants (non-flavour products only)
      var variantSel = '';
      if (hasVariants) {
        variantSel = '<div class="sb-card__variant"><select data-sb-variant aria-label="Size for ' + esc(vp.title) + '">' +
          vp.variants.map(function (vv) {
            return '<option value="' + vv.id + '"' + (String(vv.id) === String(v.id) ? ' selected' : '') +
              (vv.available ? '' : ' disabled') + '>' + esc(vv.title) +
              (vv.price !== vp.price ? ' — ' + money(vv.price, SYM) : '') + '</option>';
          }).join('') + '</select></div>';
      }
      var img = vp.image ? '<img src="' + esc(vp.image) + '" alt="' + esc(vp.title) + '" loading="lazy">' : '';
      // NOTE: a <div role=button>, NOT a <button> — a real <button> clips its block-level
      // descendants (the ingredient accordion collapsed to 0 inside one). Sample cards are
      // already divs; this keeps the dropdown inside the card border and lets max-height work.
      return '<div class="sb-card' + (chosen ? ' is-selected' : '') +
        '" role="button" tabindex="0" data-sb-card data-cat="' + esc(cat.key) + '" data-pid="' + esc(p.id) + '">' +
        '<span class="sb-card__check">' + ICON.check + '</span>' +
        '<span class="sb-card__media">' + img + '</span>' +
        (vp.brand ? '<span class="sb-card__brand">' + esc(vp.brand) + '</span>' : '') +
        '<span class="sb-card__title">' + esc(vp.title) + '</span>' +
        '<span class="sb-card__price">' +
          (ctx.compare ? '<s class="sb-card__was">' + money(ctx.compare, SYM) + '</s> ' : '') +
          money(ctx.price, SYM) + supplyTag + '</span>' +
        serveLine(ctx.price, ctx.servings) +
        flavourSel +
        variantSel +
        ingredientPanel(vp) + '</div>';
    }

    function categoryBlock(cat, idx) {
      var filled = !!sel[cat.key];
      return '<section class="sb-block' + (filled ? ' is-filled' : '') + '" data-block="' + esc(cat.key) + '">' +
        '<header class="sb-block__head">' +
          '<span class="sb-block__num">' + (idx + 1) + '</span>' +
          '<div class="sb-block__t"><h3>' + esc(cat.label) + '</h3><p>' + esc(cat.hint || ('Choose your ' + cat.label.toLowerCase())) + '</p></div>' +
          '<span class="sb-block__pick">' + (filled ? 'Selected' : 'Pick 1') + '</span>' +
        '</header>' +
        '<div class="sb-grid">' + cat.products.filter(function (p) { return p.available !== false; }).map(function (p) { return productCard(cat, p); }).join('') + '</div>' +
      '</section>';
    }

    /* ====================== RENDER: samples block ====================== */
    function sampleCard(p) {
      var v = firstAvailableVariant(p);
      var entry = samples[p.id];
      var qty = entry ? entry.qty : 0;
      var room = sampleQtyTotal() < sampleTarget();
      var img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + ' sample" loading="lazy">' : '';
      return '<div class="sb-card sb-sample' + (qty ? ' is-selected' : '') + '" data-sample-pid="' + esc(p.id) + '">' +
        (qty ? '<span class="sb-card__check">' + ICON.check + '</span>' : '') +
        '<span class="sb-card__media">' + img + '</span>' +
        '<span class="sb-card__brand">' + esc(p.brand || 'Sample') + '</span>' +
        '<span class="sb-card__title">' + esc(p.title) + '</span>' +
        '<div class="sb-sample__qty"><span class="sb-pill-free"><s class="sb-sample__rrp">' + money(v.price, SYM) + '</s> Free</span>' +
          '<span class="sb-stepper">' +
            '<button type="button" data-sample-dec' + (qty ? '' : ' disabled') + ' aria-label="Remove one ' + esc(p.title) + ' sample">&minus;</button>' +
            '<span aria-live="polite">' + qty + '</span>' +
            '<button type="button" data-sample-inc' + (room ? '' : ' disabled') + ' aria-label="Add one ' + esc(p.title) + ' sample">+</button>' +
          '</span></div>' +
      '</div>';
    }
    function samplesBlock() {
      var unlocked = pickCount() >= SAMPLES_AT;
      var total = sampleQtyTotal();
      var body;
      if (!unlocked) {
        body = '<div class="sb-lock"><i class="fi fi-rr-lock"></i><span>Pick <b>' + SAMPLES_AT +
          ' products</b> to unlock ' + energyWord(sampleTarget()) + ' of your choice.</span></div>';
      } else if (!SAMPLES.length) {
        body = '<div class="sb-lock">' + ICON.spark + '<span>Sample flavours will appear here once the samples collection is connected.</span></div>';
      } else {
        body = '<div class="sb-samples-bar"><span class="sb-samples-count"><b>' + total + '</b> / ' + sampleTarget() +
          ' samples chosen</span><span class="sb-pill-free">Free with your stack</span></div>' +
          '<div class="sb-grid">' + SAMPLES.filter(function (p) { return p.available !== false; }).slice(0, SAMPLE_SHOW).map(sampleCard).join('') + '</div>';
      }
      return '<section class="sb-block' + (unlocked ? '' : ' locked') + '" data-block="samples">' +
        '<header class="sb-block__head">' +
          '<span class="sb-block__num sb-block__num--ic">' + (unlocked ? '<i class="fi fi-rr-bolt"></i>' : '<i class="fi fi-rr-lock"></i>') + '</span>' +
          '<div class="sb-block__t"><h3>Free Energy Drinks</h3><p>' + sampleTarget() +
            ' on the house when you reach ' + SAMPLES_AT + ' picks</p></div>' +
          '<span class="sb-block__pick">' + (unlocked ? total + '/' + sampleTarget() : 'Locked') + '</span>' +
        '</header>' + body + '</section>';
    }

    /* ====================== RENDER: mystery block ====================== */
    function mysteryBlock() {
      var unlocked = pickCount() >= MYSTERY_AT;
      var inner;
      if (!unlocked) {
        inner = '<div class="sb-lock"><i class="fi fi-rr-lock"></i><span>Complete the full stack (<b>' + MYSTERY_AT +
          ' picks</b>) to roll for a free mystery gift.</span></div>';
      } else {
        var gift = mystery.length ? mystery.map(giftCard).join('') : '';
        inner = '<div class="sb-mystery' + (mystery.length ? ' revealed' : '') + '" data-mystery>' +
          '<div class="sb-dice-stage">' +
            '<span class="sb-glow" aria-hidden="true"></span>' +
            '<div class="sb-dice-wrap">' + diceHtml() + '</div>' +
            '<span class="sb-dice-shadow" aria-hidden="true"></span>' +
          '</div>' +
          '<button type="button" class="btn btn--accent lg sb-mystery__cta" data-roll><span>Reveal Your Mystery Gift' + (mysteryTarget() > 1 ? 's' : '') + '</span></button>' +
          '<div class="sb-mystery__reveal">' + gift +
            '<div><button type="button" class="sb-mystery__again" data-roll>Roll again</button></div>' +
            '<div class="sb-mystery__review" style="margin-top:18px;text-align:center"><button type="button" class="btn btn--accent lg" data-review><span>Review your stack</span></button></div>' +
          '</div></div>';
      }
      return '<section class="sb-block' + (unlocked ? '' : ' locked') + '" data-block="mystery">' +
        '<header class="sb-block__head">' +
          '<span class="sb-block__num sb-block__num--ic"><i class="fi fi-rr-gift"></i></span>' +
          '<div class="sb-block__t"><h3>Mystery Gift' + (mysteryTarget() > 1 ? 's' : '') + '</h3><p>' + (mysteryTarget() > 1 ? mysteryTarget() + ' free surprises' : 'A free surprise') + ' under ' + money(cfg.mysteryMaxPrice || 2000, SYM) + ' &mdash; roll the dice</p></div>' +
          '<span class="sb-block__pick">' + (unlocked ? (mystery.length ? 'Unlocked' : 'Roll!') : 'Locked') + '</span>' +
        '</header>' + inner + '</section>';
    }
    function giftCard(g) {
      var p = g.product, v = variantOf(p, g.variantId);
      var img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + ' mystery gift">' : '';
      return '<div class="sb-gift-card">' + img +
        '<div><div class="sb-gift-card__b">' + esc(p.brand || 'Your gift') + '</div>' +
        '<div class="sb-gift-card__t">' + esc(p.title) + '</div>' +
        '<div class="sb-gift-card__p"><s>' + money(v.price, SYM) + '</s> &nbsp;<span class="sb-pill-free">Free</span></div></div></div>';
    }

    /* ====================== RENDER: summary ====================== */
    function summary() {
      enforceTiers();                 // tier gate runs on every state change
      var n = pickCount();
      if (n >= 1 && armLeave) armLeave();   // NZS-SPD-0927-V12
      var pct = discountPct(n);
      var subtotal = 0;
      var rrpSave = 0;                 // NZS-BYS-LIVE: real RRP -> price saving across the picks
      var lines = '';
      CATS.forEach(function (cat) {
        var s = sel[cat.key];
        if (!s) return;
        var vp = selView(s);
        var v = variantOf(vp, s.variantId);
        var ctx = supplyCtx(vp, cat.key, v);
        subtotal += ctx.price;
        if (ctx.compare) rrpSave += (ctx.compare - ctx.price);           // NZS-BYS-LIVE
        lines += '<li class="sb-line" data-k="' + esc(cat.key) + '"><img src="' + esc(vp.image) + '" alt="' + esc(vp.title) + '">' +
          '<div class="sb-line__t"><div class="sb-line__cat">' + esc(cat.label) + (ctx.doubled ? ' &times;2' : '') + '</div>' +
          '<div class="sb-line__n">' + esc(vp.title) + '</div></div>' +
          '<div class="sb-line__p">' + (ctx.compare ? '<s>' + money(ctx.compare, SYM) + '</s> ' : '') + money(ctx.price, SYM) + '</div>' +
          '<button class="sb-line__x" data-remove-cat="' + esc(cat.key) + '" aria-label="Remove ' + esc(cat.label) + ' from stack">&times;</button></li>';
      });
      var sTotal = sampleQtyTotal();
      var sampleVal = 0;
      for (var sid in samples) sampleVal += samples[sid].qty * variantOf(samples[sid].product, samples[sid].variantId).price;
      if (sTotal) lines += '<li class="sb-line" data-k="samples"><div class="sb-line__t"><div class="sb-line__cat">Samples &times;' + sTotal +
        '</div><div class="sb-line__n">Pre-workout samples</div></div><div class="sb-line__p free"><s>' + money(sampleVal, SYM) + '</s> FREE</div></li>';
      var giftVal = 0;
      mystery.forEach(function (g) {
        var mv = variantOf(g.product, g.variantId);
        giftVal += mv.price;
        lines += '<li class="sb-line" data-k="mystery"><img src="' + esc(g.product.image) + '" alt="' + esc(g.product.title) + ' mystery gift">' +
          '<div class="sb-line__t"><div class="sb-line__cat">Mystery gift</div>' +
          '<div class="sb-line__n">' + esc(g.product.title) + '</div></div><div class="sb-line__p free"><s>' + money(mv.price, SYM) + '</s> FREE</div></li>';
      });
      var freeVal = sampleVal + giftVal;
      var freeRow = freeVal
        ? '<div class="sb-freeval">' + ICON.spark + '<span>You’re getting <b>' + money(freeVal, SYM) + '</b> of extras free</span></div>'
        : '';
      var discountAmt = Math.round(subtotal * pct / 100);
      var grand = subtotal - discountAmt;

      var rewards =
        reward(n >= 2, (cfg.tier2Discount || 5) + '% off your stack', 'discount') +
        reward(n >= SAMPLES_AT, energyWord(sampleTarget()), 'energy') +
        reward(n >= MYSTERY_AT, (mysteryTarget() > 1 ? mysteryTarget() + ' free mystery gifts' : 'Free mystery gift') + (n >= 4 && pct >= (cfg.tier4Discount || 10) ? ' + ' + (cfg.tier4Discount || 10) + '% off' : ''), 'mystery');

      // NZS-BYS-LIVE: real RRP savings now count too (stack discount + free extras + sale saving)
      var totalSave = discountAmt + freeVal + rrpSave;
      var totals = lines
        ? '<div class="sb-totals">' +
            '<div class="row"><span>Subtotal</span><span>' + money(subtotal, SYM) + '</span></div>' +
            (rrpSave ? '<div class="row save"><span>Sale saving</span><span>&minus;' + money(rrpSave, SYM) + '</span></div>' : '') +
            (discountAmt ? '<div class="row save"><span>Stack saving (' + pct + '%)</span><span>&minus;' + money(discountAmt, SYM) + '</span></div>' : '') +
            (totalSave ? '<div class="row save total-save"><span>Total savings</span><span>&minus;' + money(totalSave, SYM) + '</span></div>' : '') +
            '<div class="row grand"><span>Total</span><span>' + money(grand, SYM) + '</span></div>' +
          '</div>'
        : '';

      var _nt = nextTier(n);
      var _nudge = _nt ? ('add ' + _nt.need + ' more for ' + (pct ? 'an extra ' : '') + _nt.extra + '% off your order') : '';
      var _peekSub;
      if (!n) { _peekSub = 'Pick one from each block to start saving'; }
      else if (totalSave) { _peekSub = '<b class="sb-summary__save">Save ' + money(totalSave, SYM) + '</b>' + (_nudge ? ' &middot; ' + _nudge : ' &middot; full stack unlocked'); }
      else { _peekSub = _nudge ? (_nudge.charAt(0).toUpperCase() + _nudge.slice(1)) : 'Keep building your stack'; }
      elSummary.innerHTML =
        '<div class="sb-summary__head" data-sb-toggle role="button" tabindex="0" aria-expanded="false">' +
          '<div class="sb-summary__top"><h3>Your Stack</h3><span class="sb-summary__view">View your stack <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg></span></div>' +
          '<p class="sb-summary__sub">' + _peekSub + '</p>' +
        '</div>' +
        '<div class="sb-summary__body">' +
          '<div class="sb-rewards">' + rewards + '</div>' +
          (lines ? '<ul class="sb-lines">' + lines + '</ul>' : '<div class="sb-empty">Your stack is empty — start picking above.</div>') +
          freeRow +
          totals +
          '<div class="sb-cta"><button type="button" class="btn btn--accent lg" data-add ' + (n < 1 ? 'disabled' : '') + '><span>' +
            (n < 1 ? 'Pick to get started' : 'Add Stack to Cart &mdash; ' + money(grand, SYM)) + '</span></button></div>' +
          '<p class="sb-note">Discount applied automatically at checkout. Free items added with your order.</p>' +
        '</div>';

      // Animate ONLY newly-added stack lines (so existing rows don't re-"pop" on every re-render).
      var nowKeys = {};
      Array.prototype.forEach.call(elSummary.querySelectorAll('.sb-line[data-k]'), function (li) {
        var k = li.getAttribute('data-k'); nowKeys[k] = 1;
        if (!prevLineKeys[k]) li.classList.add('sb-line--in');
      });
      prevLineKeys = nowKeys;

      // ladder state
      if (elLadder) {
        Array.prototype.forEach.call(elLadder.querySelectorAll('[data-tier]'), function (t) {
          var tn = Number(t.getAttribute('data-tier'));
          t.classList.toggle('is-active', tn === n);
          t.classList.toggle('is-reached', tn <= n && n > 0);
        });
      }
      syncDrawer();                   // keep mobile drawer aria + focusability in sync
      saveState();                    // persist the in-progress stack on every change
    }
    function reward(on, label, key) {
      return '<div class="sb-reward' + (on ? ' on' : '') + '" data-reward="' + (key || '') + '">' +
        '<span class="sb-reward__ic">' + (on ? ICON.check : '') + '</span>' +
        '<span>' + label + '</span></div>';
    }
    // On mobile the summary is an off-screen drawer; reflect open state for AT
    // and make collapsed (off-screen) controls non-focusable via [inert].
    function syncDrawer() {
      var head = elSummary.querySelector('[data-sb-toggle]');
      var body = elSummary.querySelector('.sb-summary__body');
      var mobile = window.innerWidth < 1024;
      var open = elSummary.classList.contains('open');
      if (head) head.setAttribute('aria-expanded', mobile ? String(open) : 'true');
      if (body) { if (mobile && !open) body.setAttribute('inert', ''); else body.removeAttribute('inert'); }
    }
    function toggleSummary() { elSummary.classList.toggle('open'); syncDrawer(); }

    /* ====================== RENDER orchestration ====================== */
    // (Re)mount the canvas dice. The whole widget is rebuilt on every pick/roll, so the canvas node is
    // recreated each renderBlocks() — tear down the old renderer first (cancels its rAF + IO) so there
    // is never a duplicate loop or leak, then bind a fresh one if the die is on screen (>=4 picks).
    function mountDice() {
      if (diceR) { diceR.destroy(); diceR = null; }
      var cv = elBlocks.querySelector('[data-dice]');
      if (cv && cv.getContext) { diceR = createDiceRenderer(cv); diceR.init(); }
    }
    // SS2: bounce the mobile "View your stack" trigger once the shopper scrolls PAST the bottom of the
    // mystery block, to point them at it. Re-armed each render (the block is rebuilt); reset on scroll-back.
    var mysteryBounced = false, mysteryIO = null;
    function armMysteryBounce() {
      if (mysteryIO) { mysteryIO.disconnect(); mysteryIO = null; }
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var my = elBlocks.querySelector('[data-block="mystery"]');
      if (!my) return;
      mysteryIO = new IntersectionObserver(function (es) {
        var e = es[0];
        if (!e.isIntersecting && e.boundingClientRect.bottom <= 0) {   // block scrolled above the viewport top
          if (!mysteryBounced) {
            mysteryBounced = true;
            var v = elSummary.querySelector('.sb-summary__view');
            if (v) { v.classList.remove('bounce'); void v.offsetWidth; v.classList.add('bounce'); }
          }
        } else if (e.isIntersecting) { mysteryBounced = false; }
      }, { threshold: 0 });
      mysteryIO.observe(my);
    }
    function renderBlocks() {
      elBlocks.innerHTML =
        CATS.map(categoryBlock).join('') +
        samplesBlock() +
        mysteryBlock();
      mountDice();
      armMysteryBounce();
    }
    function renderAll() { renderBlocks(); summary(); }
    // targeted re-renders keep dice/scroll position stable where possible
    function refreshSamples() {
      var node = elBlocks.querySelector('[data-block="samples"]');
      if (node) node.outerHTML = samplesBlock();
      summary();
    }

    /* ====================== EVENTS ====================== */
    elBlocks.addEventListener('click', function (e) {
      // ---- Core ingredients dropdown toggle (lives inside the card button) ----
      var itog = e.target.closest('[data-ingr-toggle]');
      if (itog) {
        e.preventDefault(); e.stopPropagation();
        var wrap = itog.closest('.sb-ingr');
        if (wrap) wrap.classList.toggle('open');
        return;
      }
      // ---- category card select ----
      var card = e.target.closest('[data-sb-card]');
      if (card && !e.target.closest('[data-sb-variant]') && !e.target.closest('[data-sb-flavour]') && !e.target.closest('.sb-ingr')) {
        var ck = card.getAttribute('data-cat');
        var pid = card.getAttribute('data-pid');
        var cat = CATS.find(function (c) { return c.key === ck; });
        var prod = cat && cat.products.find(function (p) { return String(p.id) === String(pid); });
        if (!prod) return;
        if (sel[ck] && String(sel[ck].product.id) === String(pid)) {
          delete sel[ck];                         // toggle off
        } else {
          var existingFlavour = card.querySelector('[data-sb-flavour]');
          var fid = existingFlavour ? existingFlavour.value : defaultFlavourId(prod);
          var vp = viewProduct(prod, fid);
          var existingVariant = card.querySelector('[data-sb-variant]');
          var vid = existingVariant ? existingVariant.value : firstAvailableVariant(vp).id;
          sel[ck] = { product: prod, flavourId: fid, variantId: vid };
        }
        renderBlocks();                           // re-render to flip lock states
        summary();
        return;
      }
      // ---- sample steppers ----
      var inc = e.target.closest('[data-sample-inc]');
      var dec = e.target.closest('[data-sample-dec]');
      if (inc || dec) {
        var wrap = e.target.closest('[data-sample-pid]');
        var spid = wrap.getAttribute('data-sample-pid');
        var sp = SAMPLES.find(function (p) { return String(p.id) === String(spid); });
        if (!sp) return;
        if (inc) {
          if (sampleQtyTotal() >= sampleTarget()) return;
          if (!samples[spid]) samples[spid] = { product: sp, variantId: firstAvailableVariant(sp).id, qty: 0 };
          samples[spid].qty++;
        } else if (dec && samples[spid]) {
          samples[spid].qty--;
          if (samples[spid].qty <= 0) delete samples[spid];
        }
        refreshSamples();
        return;
      }
      // ---- mystery roll ----
      if (e.target.closest('[data-review]')) { addToCart(); return; }
      if (e.target.closest('[data-roll]')) { rollDice(); return; }
    });

    // keyboard select for the div-cards (Enter / Space) — they're role=button, not <button>
    elBlocks.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var t = e.target;
      if (t.closest('[data-sb-variant]') || t.closest('[data-sb-flavour]')) return;   // let the selects handle keys
      var itog = t.closest('[data-ingr-toggle]');
      if (itog) { e.preventDefault(); var iw = itog.closest('.sb-ingr'); if (iw) iw.classList.toggle('open'); return; }
      var card = t.closest('[data-sb-card]');
      if (card && card === t) { e.preventDefault(); card.click(); }
    });

    // flavour / variant change (both select the card if it wasn't already)
    elBlocks.addEventListener('change', function (e) {
      var card = e.target.closest('[data-sb-card]');
      if (!card) return;
      var ck = card.getAttribute('data-cat');
      var pid = card.getAttribute('data-pid');
      var cat = CATS.find(function (c) { return c.key === ck; });
      var prod = cat && cat.products.find(function (p) { return String(p.id) === String(pid); });
      if (!prod) return;
      var fsel = e.target.closest('[data-sb-flavour]');
      if (fsel) {                                  // flavour swap -> new sibling product + its variant + image
        var f = flavourEntry(prod, fsel.value) || flavourEntry(prod, defaultFlavourId(prod));
        if (!f) return;
        sel[ck] = { product: prod, flavourId: f.id, variantId: f.vid };
        renderBlocks(); summary();
        return;
      }
      var vsel = e.target.closest('[data-sb-variant]');
      if (vsel) {                                  // size change within a (non-flavour) product; keep any chosen flavour
        var curFid = (sel[ck] && String(sel[ck].product.id) === String(pid)) ? sel[ck].flavourId : defaultFlavourId(prod);
        sel[ck] = { product: prod, flavourId: curFid, variantId: vsel.value };
        renderBlocks(); summary();
      }
    });

    // summary clicks (remove / add / mobile toggle)
    elSummary.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove-cat]');
      if (rm) { delete sel[rm.getAttribute('data-remove-cat')]; renderBlocks(); summary(); return; }
      if (e.target.closest('[data-add]')) { addToCart(); return; }
      if (e.target.closest('[data-sb-toggle]') && window.innerWidth < 1024) toggleSummary();
    });
    // keyboard-activate the mobile drawer toggle (Enter / Space)
    elSummary.addEventListener('keydown', function (e) {
      if (e.target.closest('[data-sb-toggle]') && window.innerWidth < 1024 && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault(); toggleSummary();
      }
    });

    /* ====================== mystery dice ====================== */
    var ROLL_MS = 2450;   // safety-net reveal; must exceed the renderer's ROLLDUR (2300)
    function rollDice() {
      if (rolling) return;
      var stage = elBlocks.querySelector('[data-mystery]');
      if (!MYSTERY.length) {                      // no pool connected yet
        if (stage && !stage.querySelector('.sb-note')) {
          stage.insertAdjacentHTML('beforeend', '<p class="sb-note">Connect a &quot;mystery gift&quot; collection to enable real prizes.</p>');
        }
        return;
      }
      rolling = true;
      if (stage) {
        Array.prototype.forEach.call(stage.querySelectorAll('[data-roll]'), function (b) { b.disabled = true; });
        stage.classList.remove('rolling'); void stage.offsetWidth; stage.classList.add('rolling');  // restart glow/bob/shadow
      }
      var pool = MYSTERY.filter(function (p) { return p.available !== false; }), picks = [], need = Math.min(mysteryTarget(), pool.length);
      while (picks.length < need) { picks.push(pool.splice(Math.floor(Math.random() * pool.length), 1)[0]); }
      var done = false;
      function reveal() {                          // runs exactly once (rAF settle OR safety timeout)
        if (done) return; done = true;
        if (!stage || !stage.isConnected) { rolling = false; return; }  // widget re-rendered mid-roll
        stage.classList.remove('rolling');
        mystery = picks.map(function (p) { return { product: p, variantId: firstAvailableVariant(p).id }; });
        var rev = stage.querySelector('.sb-mystery__reveal');
        if (rev) rev.innerHTML = mystery.map(giftCard).join('') +
          '<div><button type="button" class="sb-mystery__again" data-roll>Roll again</button></div>';
        stage.classList.add('revealed');          // reveals in place — die stays on its landed pose
        var pickLabel = stage.closest('.sb-block') && stage.closest('.sb-block').querySelector('.sb-block__pick');
        if (pickLabel) pickLabel.textContent = 'Unlocked';
        // FIX: re-enable the roll controls (the old code disabled them and never restored, killing the
        // main "Reveal" button after the first roll — only "Roll again" survived via re-render).
        Array.prototype.forEach.call(stage.querySelectorAll('[data-roll]'), function (b) { b.disabled = false; });
        rolling = false;
        summary();
      }
      if (diceR) diceR.roll(reveal);              // canvas tumble -> reveal on settle
      window.setTimeout(reveal, ROLL_MS + 120);   // safety net: paused/off-screen roll, null renderer, reduced-motion
    }

    /* ====================== add to cart ====================== */
    function gatherItems() {
      enforceTiers();                 // never send unearned free items to the cart
      var paid = [], free = [], demo = false;
      CATS.forEach(function (cat) {
        var s = sel[cat.key]; if (!s) return;
        if (isPlaceholder(s.variantId)) demo = true;
        var vp = selView(s);
        var _pv = variantOf(vp, s.variantId);
        var _pvid = (_pv && _pv.available === false) ? firstAvailableVariant(vp).id : s.variantId;
        paid.push({ id: _pvid, quantity: supplyQty(vp, cat.key), properties: { _Stack: 'Build Your Stack', Category: cat.label } });
      });
      for (var id in samples) {
        if (isPlaceholder(samples[id].variantId)) demo = true;
        free.push({ id: samples[id].variantId, quantity: samples[id].qty, properties: { _Stack: 'Build Your Stack', _Free: 'Sample' } });
      }
      mystery.forEach(function (g) {
        if (isPlaceholder(g.variantId)) demo = true;
        free.push({ id: g.variantId, quantity: 1, properties: { _Stack: 'Build Your Stack', _Free: 'Mystery gift' } });
      });
      return { paid: paid, free: free, demo: demo };
    }

    function addToCart() {
      var n = pickCount();
      if (n < 1) return;
      var g = gatherItems();
      var btn = elSummary.querySelector('[data-add]');

      if (g.demo) {                               // placeholder mode — no real variants yet
        showDemo(btn);
        return;
      }
      if (btn) { btn.setAttribute('disabled', ''); btn.classList.add('is-loading'); btn.querySelector('span').innerHTML = '<svg class="nzs-ldr nzs-ldr-dots" width="26" height="26" viewBox="0 0 24 24" role="status" aria-label="Adding" style="display:inline-block;vertical-align:middle"><circle cx="4" cy="12" r="2.4" fill="currentColor"/><circle cx="12" cy="12" r="2.4" fill="currentColor"/><circle cx="20" cy="12" r="2.4" fill="currentColor"/></svg>'; }

      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // DEFER the cart-add: stash the pending stack so the review page previews it WITHOUT polluting the
      // cart. The commit happens on the review page's 'Continue' lock-in (nzs-stack-checkout.js).
      var pend = { paid: g.paid, free: g.free, pct: discountPct(n),
        attrs: {
          'Supply': SUPPLY === '60' ? '60-day' : '30-day',
          '_StackPicks': String(n),
          '_StackPct': String(discountPct(n)),
          '_StackCode': (cfg.discountCodes || {})[String(n)] || ''
        }, lines: [] };
      CATS.forEach(function (cat) {
        var s = sel[cat.key]; if (!s) return;
        var vp = selView(s);
        var ctx = supplyCtx(vp, cat.key, variantOf(vp, s.variantId));
        pend.lines.push({ vid: s.variantId, title: vp.title, image: vp.image, price: ctx.price, qty: ctx.qty, category: cat.label, free: false });
      });
      for (var psid in samples) { var psm = samples[psid], psv = variantOf(psm.product, psm.variantId);
        pend.lines.push({ vid: psm.variantId, title: psm.product.title, image: psm.product.image, price: psv.price * psm.qty, qty: psm.qty, free: true, freeType: 'sample' }); }
      mystery.forEach(function (pmg) { var pmv = variantOf(pmg.product, pmg.variantId);
        pend.lines.push({ vid: pmg.variantId, title: pmg.product.title, image: pmg.product.image, price: pmv.price, qty: 1, free: true, freeType: 'mystery' }); });
      try { sessionStorage.setItem('nzs_pending_stack', JSON.stringify(pend)); } catch (e) { }
      bypassLeave = true;
      window.location.href = routeRoot + 'pages/your-stack';
    }

    function showDemo(btn) {
      var body = elSummary.querySelector('.sb-summary__body');
      if (body && !body.querySelector('.sb-demo')) {
        var d = document.createElement('div');
        d.className = 'sb-demo';
        d.innerHTML = 'Preview mode — connect real product collections in the theme editor and checkout goes live. Your picks, tiers and gift logic are all working.';
        body.insertBefore(d, body.querySelector('.sb-cta'));
      }
      if (btn) {
        var sp = btn.querySelector('span'), old = sp.innerHTML;
        sp.innerHTML = 'Preview only';
        window.setTimeout(function () { sp.innerHTML = old; }, 1600);
      }
    }

    // ---- 30/60-day supply toggle ----
    var elSupply = root.querySelector('[data-sb-supply]');
    if (elSupply) elSupply.addEventListener('click', function (e) {
      var b = e.target.closest('[data-supply]');
      if (b) setSupply(b.getAttribute('data-supply'));
    });

    // ---- go ----
    restoreState();
    installLeaveGuard();
    updateLadder();
    renderAll();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nzs-stack]'), StackBuilder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
